module.exports = __webpack_public_path__ + "static/media/9.3d5d1c92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/landing/orders/9.jpg
// module id = 1741
// module chunks = 0